import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { LoadingWrapper } from 'barnyard/components';
import { Row, Col } from 'barnyard/layouts';
import { localStorageHelper } from '~/accounts/core/utils';
import track, { analyticsTypes } from '~/app/vet/core/analytics';
import { VENDOR_FORM_URL, USER_FORM_URL, FINISHED_URL } from '../constants';
import Stepper from './Stepper';
import BuyerInfoFormWrapper from './BuyerInfoFormWrapper';

const classNamePrefix = 'Signup--FormPage';
const localStorageSaveLocation = '_saved_buyer_form';

class BuyerInfoView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      buyerForm: localStorageHelper.retreiveJson(localStorageSaveLocation)
    };
  }

  componentDidMount() {
    track(analyticsTypes.SIGNUP_VIEW_BUYER, _.get(this.props, 'location.query', {}));
    this.props.profileFetchAction();
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps) {
    const { buyer: prevBuyer } = prevProps;
    const { buyer, router, location } = this.props;

    // If there's no buyer, force redirect to the start of the signup flow
    if (_.isNull(buyer)) {
      window.location = USER_FORM_URL;
    }

    if (buyer.has_completed_signup) {
      localStorageHelper.clear();
      window.location = location.query.next || FINISHED_URL;
      return;
    }

    if (!buyer.isError && prevBuyer.isUpdating === true && buyer.isUpdating === false) {
      router.push({
        pathname: VENDOR_FORM_URL,
        search: location.search
      });
    }
  }

  render() {
    const {
      buyerFormFieldFetches,
      buyerFormFields,
      buyerUpdateAction,
      buyer,
      profile,
    } = this.props;
    const { buyerForm } = this.state;

    return (
      <div className={classNamePrefix}>
        <Stepper
          current={1}
          showVendorStep={!_.get(buyer, 'has_requisitioned_checkouts', false)}
        />
        <LoadingWrapper loading={buyer && buyer.isLoading}>
          <Row align='middle' justify='center'>
            <Col className={`${classNamePrefix}__title`} span={12}>
              <h2>Let&apos;s Learn About Your Clinic!</h2>
              <h5>
                This information is used to verify your organization and customize your shopping experience.
              </h5>
            </Col>
            <Col span={12}>
              <BuyerInfoFormWrapper
                onFormChange={values => localStorageHelper.saveJson(localStorageSaveLocation, values)}
                initialValues={buyerForm}
                buyer={buyer}
                profile={profile}
                buyerUpdateAction={buyerUpdateAction}
                buyerFormFields={buyerFormFields}
                buyerFormFieldFetches={buyerFormFieldFetches}
                isReadOnly={false}
              />
            </Col>
          </Row>
        </LoadingWrapper>
      </div>
    );
  }
}

BuyerInfoView.propTypes = {
  profile: PropTypes.object.isRequired,
  buyer: PropTypes.object.isRequired,
  buyerFormFieldFetches: PropTypes.object.isRequired,
  buyerFormFields: PropTypes.object.isRequired,
  buyerUpdateAction: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
};

export default BuyerInfoView;
